export enum OfferEditMode {
  CREATING = 'CREATING',
  EDITING = 'EDITING',
}

export interface EditMode {
  editMode: OfferEditMode;
}
